<template>
  <div class="home">
    <site-header
      id="site-header"
      :links="links"
    ></site-header>
    <router-view id="site-content"></router-view>
    <site-footer id="site-footer"></site-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import SiteHeader from '../components/SiteHeader'
import SiteFooter from '../components/SiteFooter'

export default {
  name: 'Home',
  components: {
    SiteFooter,
    SiteHeader
  },
  data() {
    return {
      links: [
        { title: 'women', name: 'AllModels', params: { gender: 'women' }},
        { title: 'men', name: 'AllModels', params: { gender: 'men' }},
        { title: 'become a model', name: 'BecomeAModel', params: {}}
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
}

#site-footer, #site-header {
  flex-shrink: 0;
}

#site-content {
  flex-grow: 1;
}
</style>
